import React from 'react';
import { companyInfo } from '../mock';
import { CheckCircle, ExternalLink } from 'lucide-react';

const ServicesSection = () => {
  const { flowmingo } = companyInfo.services;

  return (
    <section 
      id="services"
      style={{
        background: '#000000',
        padding: '100px 7.6923%',
        position: 'relative'
      }}
    >
      <div 
        style={{
          maxWidth: '1400px',
          margin: '0 auto'
        }}
      >
        <div 
          style={{
            textAlign: 'center',
            marginBottom: '60px'
          }}
        >
          <h2 
            className="display-large"
            style={{
              marginBottom: '20px'
            }}
          >
            {companyInfo.services.title}
          </h2>
          <div 
            style={{
              width: '60px',
              height: '3px',
              background: '#00FFD1',
              margin: '0 auto'
            }}
          />
        </div>
        
        {/* Language Expertise Services Card */}
        <div 
          style={{
            background: '#121212',
            border: '1px solid rgba(255, 255, 255, 0.25)',
            padding: '60px',
            marginBottom: '40px',
            borderRadius: '0px'
          }}
        >
          <h3 
            className="display-medium"
            style={{
              marginBottom: '20px',
              color: '#00FFD1'
            }}
          >
            Language Expertise
          </h3>
          <p 
            className="body-large"
            style={{
              color: 'rgba(255, 255, 255, 0.85)',
              marginBottom: '24px'
            }}
          >
            Professional language services to help your business communicate effectively across global markets.
          </p>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px' }}>
            {['Translation', 'Transcription', 'Proofreading', 'Editing', 'Voice Over Services'].map((service, index) => (
              <div
                key={index}
                style={{
                  background: 'rgba(0, 255, 209, 0.1)',
                  border: '1px solid rgba(0, 255, 209, 0.3)',
                  padding: '12px 20px',
                  borderRadius: '0px',
                  fontSize: '16px',
                  color: '#00FFD1',
                  fontWeight: '500'
                }}
              >
                {service}
              </div>
            ))}
          </div>
        </div>

        {/* AI Website Building Service Card */}
        <div 
          style={{
            background: '#121212',
            border: '1px solid rgba(255, 255, 255, 0.25)',
            padding: '60px',
            marginBottom: '60px',
            borderRadius: '0px'
          }}
        >
          <h3 
            className="display-medium"
            style={{
              marginBottom: '20px',
              color: '#00FFD1'
            }}
          >
            AI Website Building
          </h3>
          <p 
            className="body-large"
            style={{
              color: 'rgba(255, 255, 255, 0.85)',
              marginBottom: '48px',
              lineHeight: '1.8'
            }}
          >
            Full website built with AI-generated content based on the client's specifications or content specified by the client, plus light consultant editing. Transform your online presence with a professionally designed website.
          </p>

          {/* Landing Page Section */}
          <div 
            style={{
              background: 'rgba(0, 255, 209, 0.03)',
              border: '1px solid rgba(0, 255, 209, 0.15)',
              padding: '40px',
              borderRadius: '0px',
              marginBottom: '40px'
            }}
          >
            <h4 
              className="heading-1"
              style={{
                marginBottom: '16px',
                color: '#00FFD1'
              }}
            >
              Landing Page - What's Included
            </h4>
            <p 
              className="body-medium"
              style={{
                color: 'rgba(255, 255, 255, 0.85)',
                marginBottom: '24px',
                lineHeight: '1.7'
              }}
            >
              Perfect for company description sites, author pages, product launches, service showcases, event registration, portfolio presentations, and lead generation campaigns. A landing page provides a focused, professional web presence that converts visitors into customers.
            </p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              {[
                'Header with custom logo',
                'Professional footer',
                'Sections describing your company, services, or products',
                'Contact form with email routing to your chosen address(es)',
                'Responsive design for all devices',
                '2 rounds of revisions included'
              ].map((feature, index) => (
                <div 
                  key={index}
                  style={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: '12px'
                  }}
                >
                  <div
                    style={{
                      width: '6px',
                      height: '6px',
                      background: '#00FFD1',
                      borderRadius: '50%',
                      marginTop: '10px',
                      flexShrink: 0
                    }}
                  />
                  <p 
                    className="body-medium"
                    style={{
                      margin: 0,
                      color: 'rgba(255, 255, 255, 0.85)'
                    }}
                  >
                    {feature}
                  </p>
                </div>
              ))}
            </div>
            
            {/* Landing Page Pricing */}
            <div 
              style={{
                background: 'rgba(0, 255, 209, 0.05)',
                border: '1px solid rgba(0, 255, 209, 0.2)',
                padding: '24px',
                borderRadius: '0px',
                marginTop: '24px'
              }}
            >
              <div style={{ display: 'flex', alignItems: 'baseline', gap: '12px', marginBottom: '8px' }}>
                <span 
                  style={{
                    fontSize: '20px',
                    fontWeight: '400',
                    color: 'rgba(255, 255, 255, 0.85)',
                    lineHeight: '1'
                  }}
                >
                  Starting at
                </span>
                <span 
                  style={{
                    fontSize: '36px',
                    fontWeight: '600',
                    color: '#00FFD1',
                    lineHeight: '1'
                  }}
                >
                  $350
                </span>
                <span 
                  style={{
                    fontSize: '16px',
                    fontWeight: '400',
                    color: 'rgba(255, 255, 255, 0.7)',
                    lineHeight: '1'
                  }}
                >
                  (excluding VAT)
                </span>
              </div>
              <p 
                className="body-small"
                style={{
                  margin: 0,
                  color: 'rgba(255, 255, 255, 0.85)'
                }}
              >
                Final price varies depending on website structure and features.
              </p>
            </div>
          </div>

          {/* Fullstack App Section */}
          <div 
            style={{
              background: 'rgba(0, 255, 209, 0.03)',
              border: '1px solid rgba(0, 255, 209, 0.15)',
              padding: '40px',
              borderRadius: '0px',
              marginBottom: '40px'
            }}
          >
            <h4 
              className="heading-1"
              style={{
                marginBottom: '16px',
                color: '#00FFD1'
              }}
            >
              Fullstack App - What's Included
            </h4>
            <p 
              className="body-medium"
              style={{
                color: 'rgba(255, 255, 255, 0.85)',
                marginBottom: '24px',
                lineHeight: '1.7'
              }}
            >
              Comprehensive web applications with backend functionality, perfect for e-commerce platforms, booking systems, membership sites, custom dashboards, CRM systems, project management tools, data management platforms, and social community sites. Get a fully functional application with database integration and user management.
            </p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              {[
                'Complete frontend and backend development',
                'Database integration (MongoDB)',
                'User authentication and authorization',
                'Admin dashboard for content management',
                'API endpoints for data operations',
                'Custom features based on your requirements',
                'Responsive design for all devices',
                '2 rounds of revisions included'
              ].map((feature, index) => (
                <div 
                  key={index}
                  style={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: '12px'
                  }}
                >
                  <div
                    style={{
                      width: '6px',
                      height: '6px',
                      background: '#00FFD1',
                      borderRadius: '50%',
                      marginTop: '10px',
                      flexShrink: 0
                    }}
                  />
                  <p 
                    className="body-medium"
                    style={{
                      margin: 0,
                      color: 'rgba(255, 255, 255, 0.85)'
                    }}
                  >
                    {feature}
                  </p>
                </div>
              ))}
            </div>
            
            {/* Fullstack App Pricing */}
            <div 
              style={{
                background: 'rgba(0, 255, 209, 0.05)',
                border: '1px solid rgba(0, 255, 209, 0.2)',
                padding: '24px',
                borderRadius: '0px',
                marginTop: '24px'
              }}
            >
              <div style={{ display: 'flex', alignItems: 'baseline', gap: '12px', marginBottom: '8px' }}>
                <span 
                  style={{
                    fontSize: '20px',
                    fontWeight: '400',
                    color: 'rgba(255, 255, 255, 0.85)',
                    lineHeight: '1'
                  }}
                >
                  Starting at
                </span>
                <span 
                  style={{
                    fontSize: '36px',
                    fontWeight: '600',
                    color: '#00FFD1',
                    lineHeight: '1'
                  }}
                >
                  $850
                </span>
                <span 
                  style={{
                    fontSize: '16px',
                    fontWeight: '400',
                    color: 'rgba(255, 255, 255, 0.7)',
                    lineHeight: '1'
                  }}
                >
                  (excluding VAT)
                </span>
              </div>
              <p 
                className="body-small"
                style={{
                  margin: 0,
                  color: 'rgba(255, 255, 255, 0.85)'
                }}
              >
                Final price varies depending on complexity and custom features required.
              </p>
            </div>
          </div>

          {/* Overall Pricing Summary - Removed old pricing section */}

          {/* CTA */}
          <a
            href="#contact"
            onClick={(e) => {
              e.preventDefault();
              const element = document.getElementById('contact');
              if (element) {
                const offset = 80;
                const elementPosition = element.getBoundingClientRect().top;
                const offsetPosition = elementPosition + window.pageYOffset - offset;
                window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
              }
            }}
            className="btn-primary"
            style={{
              textDecoration: 'none',
              display: 'inline-flex',
              alignItems: 'center',
              gap: '12px'
            }}
          >
            Get Your Website Started
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="5" y1="12" x2="19" y2="12"></line>
              <polyline points="12 5 19 12 12 19"></polyline>
            </svg>
          </a>
        </div>
        
        {/* Flowmingo AI Section */}
        <div 
          style={{
            background: '#121212',
            border: '1px solid rgba(255, 255, 255, 0.25)',
            padding: '60px',
            borderRadius: '0px'
          }}
        >
          <div 
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              marginBottom: '12px'
            }}
          >
            <h3 
              className="display-medium"
              style={{
                margin: 0,
                color: '#00FFD1'
              }}
            >
              {flowmingo.title}
            </h3>
          </div>
          
          <p 
            className="heading-2"
            style={{
              color: 'rgba(255, 255, 255, 0.85)',
              marginBottom: '24px'
            }}
          >
            {flowmingo.subtitle}
          </p>
          
          <p 
            className="body-large"
            style={{
              color: 'rgba(255, 255, 255, 0.85)',
              marginBottom: '40px',
              lineHeight: '1.8'
            }}
          >
            {flowmingo.description}
          </p>
          
          {/* YouTube Video Embed */}
          <div 
            style={{
              position: 'relative',
              paddingBottom: '56.25%',
              height: 0,
              overflow: 'hidden',
              marginBottom: '40px',
              background: '#000000',
              border: '1px solid rgba(255, 255, 255, 0.25)'
            }}
          >
            <iframe
              src={flowmingo.videoUrl}
              title="Flowmingo AI Demo"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                border: 'none'
              }}
            />
          </div>
          
          {/* Advantages */}
          <div style={{ marginBottom: '40px' }}>
            <h4 
              className="heading-1"
              style={{
                marginBottom: '24px'
              }}
            >
              Key Advantages
            </h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              {flowmingo.advantages.map((advantage, index) => (
                <div 
                  key={index}
                  style={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: '12px'
                  }}
                >
                  <CheckCircle 
                    size={24} 
                    color="#00FFD1" 
                    style={{ 
                      flexShrink: 0,
                      marginTop: '2px'
                    }} 
                  />
                  <p 
                    className="body-medium"
                    style={{
                      margin: 0,
                      color: 'rgba(255, 255, 255, 0.85)'
                    }}
                  >
                    {advantage}
                  </p>
                </div>
              ))}
            </div>
          </div>
          
          {/* CTA Button */}
          <a
            href={flowmingo.signupUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary"
            style={{
              textDecoration: 'none',
              display: 'inline-flex',
              alignItems: 'center',
              gap: '12px'
            }}
          >
            Set Up Your Flowmingo Account
            <ExternalLink size={20} />
          </a>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
